export default "__VITE_ASSET__uL4ZUN8o__"